<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Résilier ma ligne ({{ step }}/2)</div>

    <div class="col-12">
        @if (!displayConfirmation) {
            <div class="col-12">
                @if (line && line.endCommitmentDate) {
                    <div class="form-group text-left">
                        Vous êtes sur le point de demander la résiliation de votre ligne <span
                            class="bold-label-text">{{ line.phoneNumber }}</span>.
                        <br/>
                        Nous souhaitons vous informer que votre ligne est actuellement sous engagement jusqu'au <span
                            class="bold-label-text">{{ dateFormat(line.endCommitmentDate) }}</span>, soit encore <span
                            class="bold-label-text">{{ diffBetweenTwoDates() }} mois</span>.
                        <br/><br/>
                        <span class="bold-label-text">Détails de la Pénalité de Résiliation :</span>
                        <br/>
                        - Montant Restant Dû : <span
                            class="bold-label-text">{{ numberFormat(line.commitmentDueTTC).toString().replace('.00', '').replace('.', ',') }}
                        €</span>
                        @if (numberFormat(line.commitmentDueTTC) !== 0) {
                            <br/>
                            - Date de Fin d'Engagement : <span
                                class="bold-label-text">{{ dateFormat(line.endCommitmentDate) }}</span>,
                            <br/><br/>
                            Le montant restant dû correspond à vos mensualités restantes et sera inclus dans votre dernière
                            facture après la résiliation de votre ligne, comme suit :
                            <br/>
                            - Date de la Dernière Facture : <span
                                class="bold-label-text">{{ lastBillDate(portability, date) }}</span>
                            <br/><br/>
                            Nous vous invitons à considérer les implications financières de cette résiliation avant de procéder.
                        }
                    </div>
                }
                <div class="form-group">
                    <span class="float-left">Souhaitez-vous transférer votre numéro de téléphone <span
                      class="bold-label-text"> {{ concernsLandLine() ? landLine.phoneNumber : line.phoneNumber }}</span> chez un autre opérateur ?</span>
                    <br/>
                    <div class="row pl-4">
                        <div class="col-auto">
                            <input type="radio" id="porta1" class="form-check-input" name="portability" value="1"
                                   (click)="changePortability(true)"/>
                            <label class="form-check-label" for="porta1" style="padding-top: 2px;">Oui</label>
                        </div>
                        <div class="col-auto">
                            <input type="radio" id="porta2" class="form-check-input" name="portability" value="0"
                                   checked
                                   (click)="changePortability(false)"/>
                            <label class="form-check-label" for="porta2" style="padding-top: 2px;">Non</label>
                        </div>
                    </div>
                </div>
                @if (portability == false) {
                    <div>
                        <span class="bold-label-text float-left">Date de résiliation souhaitée (dans 10 jours minimum et 60 jours maximum) *</span>
                        <mat-form-field>
                            <input matInput class="form-control form-full-width"
                                   (dateChange)="setSelectedDate($event.value); handleManualInput(pickerInput.value)"
                                   [matDatepicker]="picker" [formControl]="firstValidDate"
                                   [matDatepickerFilter]="dateRangeFilter" #pickerInput>
                            <mat-datepicker-toggle matSuffix [for]="picker">
                                <mat-icon id="calendar-icon" svgIcon="agenda" matDatepickerToggleIcon></mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        @if (displayError || triedValidate) {
                            <small class="form-text error-message">La
                                date choisie n'est pas valide.</small>
                        }
                        <br/><br/>
                        <div class="cta_container">
                            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span>
                            </button>
                            <button type="button" class="cta_btn level_2 column" (click)="save()">Valider<span></span>
                            </button>
                        </div>
                    </div>
                }
                @if (portability) {
                    <div class="w-100">
                        <div class="text-left">
                            Pour garder votre numéro de téléphone, vous devez demander à un autre opérateur de récupérer
                            votre
                            ligne. Pour cela, appelez le 3179 depuis
                            votre {{ concernsLandLine() ? 'ligne fixe' : 'mobile' }} (appel gratuit) pour obtenir votre
                            RIO et
                            communiquez-le à votre nouvel opérateur.
                        </div>
                        <div class="cta_container">
                            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span>
                            </button>
                        </div>
                    </div>
                }
            </div>
        }
        @if (displayConfirmation) {
            <div class="col-12 w-100">
                <span class="bold-text text-danger">Etes-vous sûr de vouloir résilier votre ligne {{ concernsLandLine() ? landLine.phoneNumber : line.phoneNumber }}?</span>
                <br/>
                La résiliation de votre ligne entraînera la perte définitive de votre numéro de téléphone.
                <br/><br/>
                <div class="cta_container">
                    <button type="button" class="cta_cancel column" (click)="cancel()">Non<span></span></button>
                    <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Oui<span></span>
                    </button>
                </div>
            </div>
        }
    </div>
</div>
